import PropTypes from 'prop-types';

import { IconWarningOutline } from '@zillow/constellation';
import { Anchor, Box, Heading, Modal, Paragraph, Text } from '@zillow/constellation-10';
import { ZillowInsuranceServicesLogo } from '@zillow/zrs-comet';

import ModalFooter from '../ModalFooter';

import { ExpandableDisclaimer } from '@zillow/zrs-comet';

// the design is different from what is implemented
// if we need to update the implementation:
// TODO: add prop for heading (unless it's always zillow insurance service)
const propTypes = {
  onClose: PropTypes.func.isRequired,
  handleRentGuaranteePolicyDrop: PropTypes.func.isRequired,
  legalDisclaimer: PropTypes.arrayOf(
    PropTypes.shape({
      header: PropTypes.string,
      description: PropTypes.array,
    }),
  ).isRequired,
};
const defaultProps = {};

const RentGuaranteePolicyDropModal = ({
  premiumAmount,
  coverageAmount,
  onClose,
  handleRentGuaranteePolicyDrop,
  legalDisclaimer,
}) => {
  return (
    <Modal
      open={true}
      onOpenChange={(open) => !open && onClose()}
      header={<ZillowInsuranceServicesLogo />}
      body={
        <div data-testid="RentGuaranteePolicyDropModal">
          <Box css={{ paddingInline: { base: '200', md: '1200' }, paddingBottom: { base: '200', md: '800' } }}>
            <Box css={{ display: 'flex', alignItems: 'center', flexDirection: 'column', marginBottom: '400' }}>
              <IconWarningOutline fontColor="brand" size="lg" marginY="xs" />
              <Heading level={4}>Drop Rental Protection Request?</Heading>
            </Box>
            <Paragraph css={{ marginBottom: '400' }}>
              For just {premiumAmount}/month (plus any applicable taxes and fees),&nbsp;
              <Text>
                <Anchor href="https://www.zillow.com/z/rental-manager/rental-protection/" target="_blank">
                  Rental Protection
                </Anchor>
                &nbsp;
              </Text>
              provides up to {coverageAmount} of insurance coverage for missed rent and property damage caused by
              tenants.
            </Paragraph>
            <Paragraph css={{ marginBottom: '400' }}>
              If you change your mind, you can request&nbsp;
              <Text>
                <Anchor href="https://www.zillow.com/z/rental-manager/rental-protection/" target="_blank">
                  Rental Protection
                </Anchor>
                &nbsp;
              </Text>
              any time before your tenant signs the lease.
            </Paragraph>
            <ExpandableDisclaimer title="Legal disclaimer" disclaimerContent={legalDisclaimer} />
          </Box>
        </div>
      }
      footer={
        <ModalFooter
          submitText="Yes, drop request"
          onCancel={onClose}
          onSubmit={() => {
            handleRentGuaranteePolicyDrop();
          }}
        />
      }
      useDismissProps={{
        escapeKey: true,
        outsidePress: false,
      }}
      size={{ base: 'fullScreen', md: 'md' }}
    />
  );
};

RentGuaranteePolicyDropModal.propTypes = propTypes;
RentGuaranteePolicyDropModal.defaultProps = defaultProps;

export default RentGuaranteePolicyDropModal;
